import script from "./commonPop.vue?vue&type=script&setup=true&name=commonPop&lang=js"
export * from "./commonPop.vue?vue&type=script&setup=true&name=commonPop&lang=js"

const __exports__ = script;

export default __exports__